var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlipCupCountInStandings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "#103B5D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.0698 19H23.9302C23.4183 19 23 19.4188 23 19.9302C23 20.442 23.4188 20.8608 23.9302 20.8608H57.0698C57.5817 20.8608 58 20.442 58 19.9302C58.0005 19.4188 57.5817 19 57.0698 19Z",
    fill: "#103B5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.543 35.8387H54.4571L55.0155 30.0706H25.9846L26.543 35.8387Z",
    fill: "#103B5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7756 56.1782H52.0378L54.0843 36.6555H26.9158L28.7756 56.1782Z",
    fill: "#103B5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3109 22.8094H56.6892L56.8753 21.6926H24.1248L24.3109 22.8094Z",
    fill: "#103B5D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9618 24.4098H56.0381L56.2242 23.2935H24.7756L24.9618 24.4098Z",
    fill: "#103B5D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7058 29.3129H55.1079L55.6663 25.219H25.3335L25.7058 29.3129Z",
    fill: "#103B5D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8603 62.5028C29.8603 63.0434 30.3102 63.4855 30.8602 63.4855H50.1399C50.6899 63.4855 51.1399 63.0434 51.1399 62.5028L51.8849 56.9995H29.1152L29.8603 62.5028Z",
    fill: "#103B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipCupCountInStandings);
export default __webpack_public_path__ + "static/media/flip_cup_count_in_standings.3fb4eb38ab214f11489d1cafc32402e3.svg";
export { ForwardRef as ReactComponent };